const images = {
    fourier: require('./fourier.png'),
    gis: require('./gis.png'),
};
    
export default images;